import React from 'react';
// Components
import ManageAmaRequests from 'components/common/ManageAmaRequests';

const ManageAthleteAmaRequests: React.FC = () => {
  return <ManageAmaRequests />;
};

export default ManageAthleteAmaRequests;
